import { Inject, Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { TrackingInterface, SH_TRACKING} from '@libs/tracking';
import { AcpService } from '@services/common/acp.service';

@Component({
  standalone: false,
  selector: 'warn-pop',
  templateUrl: './warn-pop.component.html',
  styleUrls: ['./warn-pop.component.scss']
})
export class WarnPopComponent implements OnInit{
  @Input() noteTitle: string = 'Profile.Common.Txt.Note';
  @Input() showBtn2: boolean = false; //use for show cancel btn
  @Input() innerFlag: boolean = false; // innerHtml for popup descriptioin
  @Input() warnDesc: string;
  @Input() popKey: string;
  @Input() btnTxt: string = 'Profile.Common.Btn.Confirm';
  @Input() btnTxt2: string = 'Profile.Common.Btn.Cancel';

  @Output() btnActionEmit: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private acpSer: AcpService,
    @Inject(SH_TRACKING) private trackIn: TrackingInterface
  ) { }
    
  async ngOnInit() {
    if (this.popKey) { 
      this.setTrack('popup_view');
    }
   }

  public btnAction(key: string): void { 
    this.btnActionEmit.emit(key);
  }

  async setTrack(event: string) {
    this.trackIn.setTracking({
      event,
      screen_type: this.getScreenType(),
      page_name: this.getPageName(),
      popup_name: 'notice',
      popup_text: this.acpSer.getAcpText(this.warnDesc)
    });
  }

  private getScreenType(): string { 
    switch (this.popKey) {
      case 'guestEdit':
        return 'real_name';
      default:
        return null;
    }
  }

  private getPageName(): string { 
    switch (this.popKey) {
      case 'guestEdit':
        return 'tools/real_name/edit_guest';
      default:
        return null;
    }
  }
}
